import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Component that handles loading specs from URL on app initialization.
 * It checks if there's a spec name in the URL path and loads it.
 */
const UrlSpecHandler = ({ backendSpecsActions }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    if (!backendSpecsActions?.loadSpecByName) return;

    hasInitialized.current = true;

    // Get spec name from URL path (e.g., /pago-loto -> "pago-loto")
    const { pathname } = window.location;
    const specName = pathname.replace(/^\//, '').replace(/\/$/, '');

    if (specName && specName.length > 0) {
      // Load the spec by name from URL
      backendSpecsActions.loadSpecByName(specName);
    }
  }, [backendSpecsActions]);

  // This component doesn't render anything
  return null;
};

UrlSpecHandler.propTypes = {
  backendSpecsActions: PropTypes.shape({
    loadSpecByName: PropTypes.func,
  }),
};

UrlSpecHandler.defaultProps = {
  backendSpecsActions: null,
};

export default UrlSpecHandler;
